import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import SEO from "@/components/SEO";
import { useSiteSettings } from "@/hooks/useSiteSettings";

/**
 * Shared layout for legal / policy pages. Children provide the body content.
 * Uses the site's soccer-themed palette but with generous typography and
 * heavy whitespace so long-form text is easy to read on mobile.
 */
export default function LegalLayout({
  title,
  intro,
  effectiveDate,
  seoTitle,
  seoDescription,
  children,
  testid,
}) {
  const settings = useSiteSettings();
  return (
    <div data-testid={testid}>
      <SEO title={seoTitle || title} description={seoDescription || intro || title} />

      <section className="hero-black">
        <div className="container-gm py-12 md:py-16">
          <Link
            to="/"
            className="inline-flex items-center gap-2 text-white/70 hover:text-[var(--panini-yellow)] text-sm"
          >
            <ArrowLeft size={14} /> Back to home
          </Link>
          <div className="mt-6">
            <span className="sticker sticker-white">POLICY</span>
          </div>
          <h1 className="h-display text-white text-4xl md:text-6xl mt-5" data-testid="legal-title">
            {title}
          </h1>
          {intro && (
            <p className="text-white/85 mt-5 max-w-3xl text-base md:text-lg leading-relaxed">
              {intro}
            </p>
          )}
          {effectiveDate && (
            <div className="mt-5 text-white/60 text-xs font-mono">
              Effective date: {effectiveDate}
            </div>
          )}
        </div>
        <div className="field-line" aria-hidden />
      </section>

      <section className="container-gm py-14 md:py-20">
        <div className="max-w-3xl mx-auto legal-prose text-[var(--ink)]">
          {children}
        </div>

        <div className="max-w-3xl mx-auto mt-14 rounded-2xl border-2 border-[var(--ink)] bg-[var(--panini-yellow-soft)] p-6 md:p-7">
          <div className="kicker kicker-red">Important note</div>
          <p className="mt-3 text-sm leading-relaxed text-[var(--ink)]/85">
            {settings.disclaimer_footer}
          </p>
        </div>
      </section>
    </div>
  );
}
